// Hebrew year labels.
//
// Year names used to come out of a hand-written lookup table that only covered
// 5774-5804, so any year outside it rendered blank. These helpers spell the
// label out of the number instead (gematriya), which keeps working for every
// year the date picker offers.

const HUNDREDS = ['', 'ק', 'ר', 'ש', 'ת', 'תק', 'תר', 'תש', 'תת', 'תתק'];
const TENS = ['', 'י', 'כ', 'ל', 'מ', 'נ', 'ס', 'ע', 'פ', 'צ'];
const ONES = ['', 'א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט'];

// 15 and 16 are written ט"ו / ט"ז rather than the literal י"ה / י"ו, which
// would spell out a name of God.
const gematriyaLetters = (value: number): string => {
  const hundreds = HUNDREDS[Math.floor(value / 100)] ?? '';
  const remainder = value % 100;

  if (remainder === 15) return `${hundreds}טו`;
  if (remainder === 16) return `${hundreds}טז`;

  return `${hundreds}${TENS[Math.floor(remainder / 10)]}${ONES[remainder % 10]}`;
};

// A single letter takes a geresh, several take a gershayim before the last one.
const punctuate = (letters: string): string => {
  if (letters.length < 2) return letters ? `${letters}'` : '';
  return `${letters.slice(0, -1)}"${letters.slice(-1)}`;
};

/**
 * Hebrew label for a Hebrew year, e.g. 5786 -> תשפ"ו.
 * The millennium is dropped, as it is when a Hebrew date is written by hand.
 * Anything that is not a usable year is handed back as plain digits.
 */
export const formatHebrewYear = (year: number | string): string => {
  const numeric = Math.floor(Number(year));
  if (!Number.isFinite(numeric) || numeric <= 0) return String(year ?? '');

  const label = punctuate(gematriyaLetters(numeric % 1000));
  return label || String(numeric);
};
